import { useCallback } from 'react';

import { restartGraphQLSubscriptionsWebSocket } from 'common/graphql/utils';
import useCompanyContext from 'common/hooks/useCompanyContext';
import useErrorHandledMutation from 'common/hooks/useErrorHandledMutation';
import { APPLICATION_TYPE_STORAGE_KEY } from 'features/Onboarding/common/localStorage/applicationType';

import {
  StartNewOnboardingDocument,
  StartNewOnboardingMutation,
  StartNewOnboardingMutationVariables,
} from '../mutations/startNewOnboarding.gql';

const useCreateNewAccount = () => {
  const { setCompanyContext } = useCompanyContext();

  const [startNewOnboarding, mutationResult] = useErrorHandledMutation<
    StartNewOnboardingMutation,
    StartNewOnboardingMutationVariables
  >(StartNewOnboardingDocument);

  const createNewAccount = useCallback(async () => {
    localStorage.removeItem(APPLICATION_TYPE_STORAGE_KEY);

    const { data } = await startNewOnboarding();

    // Restart the websocket connection to ensure GraphQL subscriptions will
    // work on the new account.
    restartGraphQLSubscriptionsWebSocket();

    const companyProfileId =
      data?.startNewOnboarding?.company?.companyProfileId;

    setCompanyContext({
      companyProfileId,
      companyUserId: undefined,
    });
  }, [startNewOnboarding, setCompanyContext]);

  return [createNewAccount, mutationResult] as const;
};

export default useCreateNewAccount;
